import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export {
  Controls,
  Field,
  FieldLabel,
} from "~/feature/chart/components/ChartDialog/ChartDialog.styles";

export const Stack = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(3),
}));

export const SizeRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2.5),
}));

export const SizeDash = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  paddingBottom: theme.spacing(1),
}));
